  <!-- HEADER -->
<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>{{ dialogTitle }}</div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- CONTENT -->
<mat-dialog-content class="mat-typography">
  <div class="mandatory-info">
    <span class="appLabelText">
      (<span class="required-asterisk">*</span>) Marked fields are Mandatory
    </span>
  </div>

  <form #attachDocForm="ngForm" id="loadSlipForm" class="form-container">

    <div class="form-field-group">

      <!-- DOCUMENT TYPE -->
      <mat-form-field appearance="outline" class="full-width-field">
        <mat-label>
          Document Type <span class="required-asterisk"></span>
        </mat-label>
        <mat-select [(ngModel)]="docTypeId"
                    name="docTypeId"
                    required
                    (selectionChange)="onDocTypeChange()"
                    #docTypeInput="ngModel">
          <mat-option [value]="null">- Select DocType -</mat-option>
          @for (docType of docTypes; track trackById(docType.id, docType)) {
          <mat-option [value]="docType.id">{{ docType.docType }}</mat-option>
          }
        </mat-select>

        <mat-error *ngIf="docTypeInput.invalid && (docTypeInput.dirty || docTypeInput.touched)">
          Document type is required
        </mat-error>
      </mat-form-field>

      <!-- ATTACH DOCUMENT -->
      <div class="drop-zone-wrapper">
        <mat-label class="attach-label">Attach Document(s)*</mat-label>

        <div class="drop-zone"
             (click)="fileInput.click()"
             (dragover)="onDragOver($event)"
             (drop)="onDrop($event)">
          <p class="drop-text">Drag & Drop files here or click to select</p>

          <button type="button" class="choose-btn">Choose Files</button>

          <span class="file-info">
            {{ selectedFiles?.length ? (selectedFiles.length + ' file(s) selected') : 'No file chosen' }}
          </span>

          <input type="file"
                 #fileInput
                 hidden
                 multiple
                 ngModel
                 name="loadSlipFiles"
                 (change)="onFileSelected($event)" />
        </div>
        <div class="selected-files" *ngIf="selectedFiles?.length">
          <div class="file-row" *ngFor="let file of selectedFiles">
            <span class="file-name">{{ file.name }}</span>
            <button mat-icon-button
                    color="warn"
                    (click)="removeFile(file)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <!-- Validation -->
        <div *ngIf="attachDocForm.controls['loadSlipFiles']?.invalid &&
                      (attachDocForm.controls['loadSlipFiles']?.dirty ||
                       attachDocForm.controls['loadSlipFiles']?.touched)"
             class="text-red-500 text-xs">
          <div *ngIf="attachDocForm.controls['loadSlipFiles']?.errors?.['required']" style="color: red;">
            A document is required.
          </div>
        </div>
      </div>

    </div>
  </form>
</mat-dialog-content>
<!-- FOOTER -->
<mat-card-actions class="dialog-footer">
  <button mat-raised-button color="primary" (click)="onClose()">Close</button>
  <button mat-raised-button
          color="primary"
          (click)="onUploadDocument()">
    Upload
  </button>
</mat-card-actions>

